'use client';

import { cn } from '@ui/lib/utils';
import { Loader2 } from 'lucide-react';

export default function Loading({ className = '' }: { className?: string }) {
  return <Loader2 className={cn('animate-spin', className)} />;
}
